import React from 'react'
import SharePageHeader from '../SharePageHeader'

export default function SharedInfluencerHeader() {
  return <SharePageHeader />
}
